import { ReactSVG } from 'react-svg';
// @mui
import { Badge, List, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Scrollbar from '../../../components/Scrollbar';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import { useAlertPopover } from './hooks/useALertPopover';
import UpdateItem from './UpdateItem';
import Loading from '../../../components/Loading';

// ----------------------------------------------------------------------

export default function AlertsPopover() {
  const { 
    handleOpen,
    handleClose,
    open,
    updatesList,
    showNotify,
    setUpdatesList,
    loading
   } =
    useAlertPopover();
  const { t } = useTranslation();
  return (
    <>
      <IconButtonAnimate color={open ? 'primary' : 'default'} onClick={handleOpen} sx={{ width: 36, height: 36 }}>
        <Badge badgeContent={showNotify} color="error">
          <ReactSVG
            className={showNotify > 0 ? 'bell' : null}
            src="/icons/warning-2.svg"
            style={{ width: 24, height: 24 }}
          />
        </Badge>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{ width: 300, px: 2, py: 1, mt: 1.5, ml: 0.75 }}
      >
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Typography variant="body2" fontSize={14}>
            {t('Update Center')}
          </Typography>

          {/* <Button color="inherit" size="small" sx={{ typography: 'caption' }} onClick={() => {}}>
            {t('Download All')}
          </Button> */}
        </Stack>

        {loading && (
          <div>
            <Loading />
          </div>
        )}


        {!loading && 
          (updatesList.length > 0 ? (
            <Scrollbar sx={{ maxHeight: { xs: 340, sm: '75vh' }, my: 1 }}>
              <List disablePadding>
                {updatesList.map((update, index) => (
                  <UpdateItem key={update.Id || index} data={update} setUpdatesList={setUpdatesList}/>
                ))}
              </List>
            </Scrollbar>
          ) : (
            <Typography variant="body2" color="#aaa" sx={{ textAlign: 'center', my: 8 }}>
              {t('No updates found')}
            </Typography>
          ))}
      </MenuPopover>
    </>
  );
}
